import { FormConfig, FormValues } from '@topdanmark-onlinesolutions/claim-form-types';

/**
 * Determines if an upload is required based on the form id and optionally values.
 * @param formConfig - The configuration of the form.
 * @param formValues - The current values of the form.
 * @returns A boolean indicating if an upload is required.
 */
export const getUploadIsRequiredByFormIdAndValue = (
    formConfig: FormConfig | undefined,
    formValues: FormValues
): boolean => {
    if (!formConfig) {
        return false;
    }

    const { formId } = formConfig;

    switch (formId) {
        case 'parkeringsskade-privat':
            return true;
        case 'paakoert-bagfra-privat':
            return (
                valueExistInCheckboxList(formValues, 'whichVehiclesWereDamaged', 'myVehicle') ||
                valueExistInCheckboxList(formValues, 'whichVehiclesWereDamaged1', 'myVehicle')
            );
        case 'ramt-en-genstand-privat':
        case 'ramt-en-person-privat':
        case 'ramt-et-dyr-privat':
        case 'ramt-et-koeretoej-privat':
        case 'trafikale-skader-andet-privat':
            return valueExistInCheckboxList(formValues, 'whichVehiclesWereDamaged', 'myVehicle');
        default:
            return false;
    }
};

/**
 * Checks if a specific value exists in a checkbox list within the form values.
 * @param formValues - The current values of the form.
 * @param fieldName - The name of the checkbox list field.
 * @param value - The value to check for.
 * @returns A boolean indicating if the value exists in the checkbox list.
 */
const valueExistInCheckboxList = (formValues: FormValues, fieldName: string, value: string): boolean => {
    const field = formValues[fieldName];

    if (!field) {
        return false;
    }

    if (Array.isArray(field) && field.length > 0) {
        const foundField = field.find((item: { label: string; value: string }) => item.value === value);
        return foundField ? foundField.value : false;
    } else {
        return false;
    }
};

export const getAutoFlowByFormId = (formConfig: FormConfig | undefined): boolean => {
    if (!formConfig) {
        return false;
    }
    if (formConfig?.formId) {
        return [
            'parkeringsskade-privat',
            'paakoert-bagfra-privat',
            'ramt-en-genstand-privat',
            'ramt-en-person-privat',
            'ramt-et-dyr-privat',
            'ramt-et-koeretoej-privat',
            'trafikale-skader-andet-privat'
        ].includes(formConfig.formId);
    }
    return false;
};
